import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
export interface KRAMasterState {
  data: [] | null | any;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allKRAMaster: [] | null | any;
}
const initialState: KRAMasterState = {
  data: null,
  totalRecords: null,
  totalPages: null,
  currentPage: null,
  allKRAMaster: null
};
export const kRAMasterSlice = createSlice({
  name: 'kRAMaster',
  initialState,
  reducers: {
    setAllKRAMaster: (state, action) => {
      state.allKRAMaster = action.payload.data;
    },
    setKRAMaster: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    setAllKRAMasterBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    reset: (state) => {
      state = initialState;
    },
  },
});
// Action creators are generated for each case reducer function
export const { setAllKRAMaster, setKRAMaster, setAllKRAMasterBySearch,reset } = kRAMasterSlice.actions;
export const allKRAMasterDetails = (state: RootState) => state.kRAMaster.allKRAMaster;
export const getAllKRAMasterDetails = (state: RootState) => state.kRAMaster.data;
export const getKRAMasterTotalRecords =(state:RootState)=>state.kRAMaster.totalRecords;
export const getAllKRAMasterBySearch = (state: RootState) => state.kRAMaster.data;
export default kRAMasterSlice.reducer;